import Splide from '@splidejs/splide';

const onPromotedItemsLoad = () => {
  const promotedItems = document.getElementsByClassName('promoted-items');
  if (!promotedItems) return;

  Array.from(promotedItems).forEach((item) => {

    new Splide(item, {
      autoWidth: true,
      perPage: 1,
    }).mount();
  });
};

export default onPromotedItemsLoad;
